/*
 * @Author: hujingyang
 * @Description:精准营销
 * @LastEditors: yang chenglin
 */

import React, { useEffect, useState } from 'react';
import { Tab } from '@alifd/next';
import style from './index.module.scss';
import ParagraphTitle from '@/components/ParagraphTitle';
// import PageTitle from '@/pages/OrderSelection/components/PageTitle';
import Chart_OrderLifeCycleMonitoring from '@/pages/OrderSelection/components/Chart_OrderLifeCycleMonitoring';
import Tabs_orderSelection from '@/pages/OrderSelection/components/Tabs_orderSelection';
import Tabs_marketingActivityList from '@/pages/OrderSelection/components/Tabs_marketingActivityList';
// import CrowdMarketing from '@/pages/CrowdMarketing';
import utils from '@/common/utils';
import { event, store } from '@ice/stark-data';

const TabItem = Tab.Item;

/** 精准营销 */
const orderSelection = (): JSX.Element => {
  const [isLoading, setLoading] = useState(false);// 是否正在加载页面数据

  const [currentTabKey, setCurrentTabKey] = useState('crowdMarketing');// 当前tab
  // const tabsList = { crowdMarketing: '人群营销', orderSelection: '订单筛选营销' };// tabs字典

  const [currentTabKey_orderSelect, setCurrentTabKey_orderSelect] = useState('childTabs_orderSelect');// 当前tab - 订单筛选营销
  const tabsList_orderSelect = { childTabs_orderSelect: '订单筛选', childTabs_crowdList: '营销活动列表' };// tabs字典 - 订单筛选营销

  useEffect(() => {
    init();
  }, [currentTabKey]);

  /** 初始化函数 */
  const init = (): void => {
    getPageData();


    // 从父组件中获取已保存的currentTabKey，如果该可以为本页面tabs的key,则直接赋值，否则使用原有默认值
    const setPageTabKey = store.get('currentTab');
    const setPageTabKey_child = store.get('currentTab_child');
    // 设置当前tab 高亮
    // changeTabs(tabsList[setPageTabKey] ? setPageTabKey : currentTabKey);
    changeTabs_orderSelect(tabsList_orderSelect[setPageTabKey_child] ? setPageTabKey_child : currentTabKey_orderSelect);

    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 500);
  };
  /**  获取数据 */
  const getPageData = (): void => {
    // 订单状态字典
  };

  /**
   * tabs 改变时触发
   * @param tabKey string
   */
  // const changeTabs = (tabKey: string): void => {
  //   setCurrentTabKey(tabKey);

  //   /** 设置Header面包屑 */
  //   utils.setBreadcrumb({
  //     name: '精准营销', // 一级页面名称
  //     url: '/web/orderSelection', // 一级页面url
  //     children: {
  //       name: tabsList[tabKey], // 一级页面名称
  //       url: '/web/orderSelection', // 一级页面url
  //     },
  //   });

  //   // 将当前key 传入父组件
  //   event.emit('currentTab', tabKey);
  // };

  /**
   * tabs 改变时触发 - 订单筛选营销模块
   * @param tabKey string
   */
  const changeTabs_orderSelect = (tabKey: string): void => {
    setCurrentTabKey_orderSelect(tabKey);

    // /**设置Header面包屑 */
    utils.setBreadcrumb({
      name: "精准营销",//一级页面名称
      url: "/web/orderSelection",//一级页面url
      children: {
        name: '订单筛选营销',//一级页面名称
        url: "/web/orderSelection",//一级页面url
      }
    })

    // 将当前key 传入父组件
    event.emit('currentTab_child', tabKey);
  };


  const tabsList = { childTabs_orderSelect: '订单筛选', childTabs_crowdList: '营销活动列表' };// tabs字典


  return (
    <>

      <div className="setTabsStyle">
        {/* 页面tabs shape="wrapped" */}
        {/* <Tab
          animation
          navClassName={style.tabsStyle}
          onChange={changeTabs}
          activeKey={currentTabKey}
          className="tabStyle_hjy"
        >
          {Object.keys(tabsList).map((key) => {
            return (<TabItem title={tabsList[key]} key={key} />);
          })}
        </Tab> */}


        {/* <div className={style.mainBox}> */}


          {/* 人群营销 */}

          {/* {currentTabKey === 'crowdMarketing' && (<div><CrowdMarketing attr-intro="Tabs - 人群营销" /></div>)} */}


          {/* 订单筛选模块 */}
          {/* {
            currentTabKey === 'orderSelection' && (
              <div>*/}
                <Tab
                  // navClassName="childTabs_orderMoudles"
                  onChange={changeTabs_orderSelect}
                  activeKey={currentTabKey_orderSelect}
                  animation
                  navClassName={style.tabsStyle}
                  className="tabStyle_hjy"
                >
                  {Object.keys(tabsList).map((key) => {
                    return (<TabItem title={tabsList[key]} key={key} />);
                  })}
                </Tab>


                {
                  currentTabKey_orderSelect == 'childTabs_orderSelect' && <div attr-intro="订单筛选模块" className={style.mainBox}>
                  <div className={style.childBox}>
                    <ParagraphTitle title="订单生命周期监控" subtitle="" />
                    <Chart_OrderLifeCycleMonitoring attr-intro="订单生命周期监控组价" />
                  </div>

                  <Tabs_orderSelection attr-intro="订单筛选列表" />
                </div>
                }
                {
                  currentTabKey_orderSelect == 'childTabs_crowdList' && <div attr-intro="营销活动列表模块" className={style.mainBox}>
                  <Tabs_marketingActivityList attr-intro="营销活动列表" />
                </div>
                }
            {/*  </div>

             ) */}

            {/* <Loading visible={isLoading} fullScreen hidden>
            </Loading> */}
          {/* } */}
        {/* </div> */}
      </div>
    </>
  );
};


export default orderSelection;
